import Head from 'next/head'
import React from 'react'

import ConceptSteps from '../components/ConceptSteps'
import RenderPageBuilder from '../components/RenderPageBuilder'
import sanity from '../sanity'
import { sanityPageQuery } from '../sanity/page'
import { getBrandName, getDomain } from '../utils/substores.config'

type Props = {
  page: any
  steps: any[]
}

const Concept = (props: Props) => {
  const hero = props.page.pageBuilder.filter(el => el._type === 'hero')
  const rest = props.page.pageBuilder.filter(el => el._type !== 'hero')

  return (
    <div>
      <Head>
        <title>
          Sådan virker {getBrandName('Justdrive')} | {getBrandName('Justdrive')} - bil i 120 dage
        </title>
        <meta
          name="description"
          content="Bil i 120 dage, hvor alt du bare skal tænke på at køre. Vi er hverken minilease, leasing eller andet. Vi er bil i 120 dage."
        />
        <link rel="canonical" href={`${getDomain()}/hvordan-virker-det/`} />
        <meta property="og:locale" content="da_DK" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={`Sådan virker ${getBrandName('Justdrive')} | ${getBrandName('Justdrive')} - bil i 120 dage`} />
        <meta
          property="og:description"
          content="Bil i 120 dage, hvor alt du bare skal tænke på at køre. Vi er hverken minilease, leasing eller andet. Vi er bil i 120 dage."
        />
        <meta property="og:url" content={`${getDomain()}/hvordan-virker-det/`} />
        <meta property="og:site_name" content={getBrandName('Justdrive')} />
        <meta property="article:modified_time" content="2023-02-11T21:06:20+00:00" />
        <meta
          property="og:image"
          content={`${getDomain()}/wp-content/uploads/elementor/thumbs/xc40-comfort-0-16x9-1-p9t0rk076rj5os5hiwq0lsrtsupvnrj55ex28pfzow.jpg`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Estimeret læsetid" />
        <meta name="twitter:data1" content="7 minutter" />
      </Head>
      <RenderPageBuilder blocks={hero} />

      <ConceptSteps data={props.steps} />

      <RenderPageBuilder blocks={rest} />
    </div>
  )
}

export async function getStaticProps() {
  const page = await sanity.fetch<any>(sanityPageQuery('concept'))
  const steps = await sanity.fetch(`*[_type == "concept"] | order(index asc)`)

  return {
    props: {
      page,
      steps,
    },
  }
}

export default Concept
